<template>

    <button type="submit" v-bind="$attrs"
        class="inline-flex items-center justify-center rounded-md border border-transparent bg-blue-600 px-6 py-3 text-base font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
        {{ label }}</button>

</template>

<script>

export default {
    props: {
        label: {
            type: String,
            default: "",
        }
    }
}

</script>